module.exports = __webpack_public_path__ + "img/ueber-mich_640.e52fdfa8.png";